import pathfinder from '@fiverr-private/pathfinder';
import { FaqQuestion } from './types';

export const FAQ_COPY_PREFIX = 'logged_out_homepage.faqs';

export const getFaqQuestions = (): FaqQuestion[] => [
    {
        key: 'question_1',
        links: {
            fiverrLink: pathfinder('root'),
            aiServicesLink: pathfinder('short_category_nested_sub_category', {
                category_id: 'programming-tech',
                id: 'chatbots',
                nested_sub_category_id: 'ai-chatbot-development',
            }),
        },
    },
    {
        key: 'question_2',
        links: {
            postABriefLink: pathfinder('help_center_article', {
                article_id: '4415601609361-Post-a-project-brief-get-tailored-offers-for-your-project',
            }),
        },
    },
    {
        key: 'question_3',
        links: {
            howFiverrWorksLink: pathfinder('content_pages_page', { page_slug: 'how-fiverr-works' }),
        },
    },
    {
        key: 'question_4',
        links: {
            freelancerLevelSystemLink: pathfinder('content_pages_page', { page_slug: 'freelancers-levels-ratings' }),
        },
    },
    {
        key: 'question_5',
    },
    {
        key: 'question_6',
        links: {
            resourceGuidesLink: pathfinder('education_hub_render'),
        },
    },
];
